var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMParticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A",
    transform: "translate(9.18 11.16)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "19.92 18.92 19.92 25.22 29.86 18.92 29.86 12.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.96 18.92 9.96 25.22 19.92 18.92 19.92 12.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 18.92 0 25.22 9.96 18.92 9.96 12.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.86 0 19.92 6.3 19.92 12.6 29.86 6.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.92 0 9.96 6.3 9.96 12.6 19.92 6.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.96 0 0 6.3 0 12.6 9.96 6.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMParticle);
export default __webpack_public_path__ + "static/media/mParticle.7f4f6660.svg";
export { ForwardRef as ReactComponent };